module.exports = __webpack_public_path__ + "img/edit.450878e9.png";